import { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Button, Input, Modal } from 'antd'
import { useNotification } from '@/Ship/Hooks/useNotification'
import { SendPushModalStore } from '../../Stores/SendPushModalStore'

interface SendPushModalProps {
    assignmentUuid: string
    open: boolean
    onClose: () => void
}

export const SendPushModal = observer(({ assignmentUuid, open, onClose }: SendPushModalProps) => {
    const [store] = useState(() => new SendPushModalStore())
    const { showSuccess, showError } = useNotification()

    const handleSend = async () => {
        const ok = await store.send(assignmentUuid, { success: showSuccess, error: showError })
        if (ok) onClose()
    }

    return (
        <Modal
            open={open}
            title="Відправити push-повідомлення"
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Скасувати
                </Button>,
                <Button key="send" type="primary" loading={store.loading} onClick={handleSend}>
                    Відправити
                </Button>,
            ]}
        >
            <Input.TextArea
                rows={4}
                placeholder="Текст повідомлення для водія"
                value={store.message}
                onChange={(e) => store.setMessage(e.target.value)}
            />
        </Modal>
    )
})
